import { io, Socket } from 'socket.io-client';
import { REALTIME_URL } from './constants';

// Types for realtime packets
export interface RealtimePacket {
  envelope: {
    key: string;
    identities?: string[];
    channel?: string;
    notification?: string;
  };
  meta: {
    type: string;
    uuid: string;
  };
  payload: Record<string, unknown>;
}

// Server -> Client events
interface ServerToClientEvents {
  identified: (connectionId: string) => void;
  published: (data: RealtimePacket) => void;
}

// Client -> Server events
interface ClientToServerEvents {
  identify: (data: { user_uuid: string; role?: string }) => void;
  join: (data: { channel: string }) => void;
  send: (data: object) => void;
}

// Create typed socket instance
const socket: Socket<ServerToClientEvents, ClientToServerEvents> = io(
  REALTIME_URL,
  {
    autoConnect: false,
    transports: ['websocket'],
    query: {
      morty_token: null as unknown as string,
    },
  }
);

export default socket;
